export const labels = {
	cantOpenPartnerWindow: {
		label: "Label.MobileCreator.PhotoSource.CantOpenPartnerWindow",
		default: "Failed to open a popup. It might be blocked by a popup blocker.",
	},
} as const;
